import { Spin } from "antd"
import './style.scss'
import { selectLoading, selectLoadingCount } from "../../store/slices/loadingSlice"
import { useSelector } from "react-redux"
const LoadingGlobal = () => {
  const isLoading = useSelector(selectLoading)
  // console.log(useSelector(selectLoadingCount));

  return (
    isLoading ? (
      <div
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
      >
        <Spin size="large" />
      </div>
    ) :
      <></>

  )
}
export default LoadingGlobal
